import { useDispatch, useSelector } from "react-redux";
import {
  changeMatchState,
  changeUserMode,
} from "../redux/slices/userModeSlice";
import { setArray } from "../redux/slices/finishedTilesArraySlice";
import { setBalance } from "../redux/slices/userSlice";
import { beforePlay, wonGame } from "../redux/types/userModeTypes";
import { cashOutApi } from "../api/cashOutApi";
import { arrayLength } from "../config";
import cashoutMusic from "../audios/cashout.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "./getSoundEffectVolume";

const useCashOut = () => {
  const sounds = useSelector((state) => state.sounds);
  const user = useSelector((state) => state.user);

  const [playCashoutSound] = useSound(cashoutMusic, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const dispatch = useDispatch();

  const cashOut = async () => {
    try {
      const res = await cashOutApi(user.uid);
      playCashoutSound();
      let myArray = new Array(arrayLength);
      myArray.fill("win");
      res.minesIndexes.forEach((i) => {
        myArray[i] = "lose";
      });
      dispatch(setArray(myArray));
      dispatch(changeUserMode(beforePlay));
      dispatch(changeMatchState(wonGame));
      dispatch(setBalance(res.currentBalance));
    } catch (e) {}
  };

  return cashOut;
};

export default useCashOut;
